import {Component, Input, OnInit} from '@angular/core';
import {
  TipoProduto_E_OperadoraComponent,
  TipoProduto_E_OperadoraEnum,
} from 'src/app/api/module/erp/shared/enumerable/tipo-produto.enum';

@Component({
  selector: 'app-formulario-beneficiario-proposta',
  templateUrl: './formulario-beneficiario-proposta.component.html',
  styleUrls: ['./formulario-beneficiario-proposta.component.scss'],
})
export class FormularioBeneficiarioPropostaComponent implements OnInit {
  @Input() entidadeProposta: string = '';
  @Input() razaoSocialEntidade: string = '';
  @Input() codigoProposta: string = '';
  @Input() vigenciaProposta: string = '';
  @Input() listaBeneficiariosFormulario: any;
  tipoProdutoEnum = TipoProduto_E_OperadoraEnum;
  @Input() tipoProduto!: TipoProduto_E_OperadoraEnum;

  @Input() dadosOperadoraDM!: any;
  @Input() dadosOperadoraCabecalho!: any;
  @Input() heMedSenior!: any;

  operadoraVM: any;
  constructor() {}
  ngOnInit(): void {
    this.operadoraVM = this.carregarDadosOperadora();
  }
  isOdonto(): boolean {
    return TipoProduto_E_OperadoraComponent.isOdonto(this.tipoProduto);
  }

  carregarDadosOperadora(): string {
    const cnpjOperadoraFiltro = this.dadosOperadoraDM && this.dadosOperadoraDM.operatorObject.cnpj;
    if (!cnpjOperadoraFiltro) {
      return '../../../../../../assets/app-assets/images/logos-empresas/default.png';
    }
    // Busca os dados da operadora pelo CNPJ
    const dadosOperadora = TipoProduto_E_OperadoraComponent.getByCnpj(cnpjOperadoraFiltro);

    // Retorna o logo dos dados ou um padrão
    return dadosOperadora;
  }
}
